import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";

import { Paper, Tabs, Tab } from "@mui/material";
import { FormControl, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useFormik } from "formik";
import { getClassSiteList } from "../../Settings/_redux/franchises/franchisesCrud";
import { newOrderCollectionValue } from "../orderUtils";
import { ContainerModalCompoent } from "../NewOrder/components/ContainerModalCompoent";
import SnackBarTool from "../../../../_metronic/_partials/widgets/snack-bar/SnackBar";
import {
  collectionExtraChage,
  containerDateUpdate,
  containerExtraChage,
  extraMiles,
  getAddress,
} from "../_redux/order/orderCrud";
import { LoadingSpinner } from "../../../../_metronic/_partials/controls/LoadingSpinner";
import { useIntl } from "react-intl";
import {
  calculateExtraPrice,
  convertKilometersToMiles,
  getInputClasses,
} from "../../../utils/commonFunction";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import {
  capitalizeFirstLetter,
  divideByHundred,
} from "../../../utils/canvaCloseFunction";
import CustomeOrderSaveDialog from "../../../../_metronic/_partials/widgets/alert/CustomeOrderSaveDialog";
import { fetchMyOrderDetailCard } from "../_redux/order/orderAction";
import { useDispatch } from "react-redux";

/**
 * The pop-up behind the Move In, Collection, Return and Move Out tabs of a
 * container order: the date and details for that step, the charges that go
 * with it as tick boxes, and their total.
 *
 * @param {Object} props
 * @param {boolean} props.show Whether the pop-up is open.
 * @param {Function} props.setShow Opens or closes it.
 * @param {string} props.keyC The tab it was opened from ("moveIn", "collection", "return" or "moveOut").
 * @param {Object} props.initialValues The form's starting values for that tab.
 * @param {Object} props.orderDetail The order being edited.
 * @returns {JSX.Element}
 */
export function OrderContainerCollectionModal({
  dispatchReducer,
  state,
  show,
  setShow,
  initialValues,
  franchise,
  keyC,
  check,
  orderDetail,
}) {
  const intl = useIntl();
  const [value, setValue] = React.useState({});
  const [snack, setSnack] = useState({ call: false, type: "", message: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});
  // The move-out Storage Cost box: null until staff tick or untick it
  // themselves while this pop-up is open, then the choice they made.
  const [storageCostChoice, setStorageCostChoice] = useState(null);
  // True while the price for the selected return/move-out date is loading;
  // Save stays off until it arrives, so a price for another date is never sent.
  const [quoteLoading, setQuoteLoading] = useState(false);
  // The lookup (a quoteKey, below) whose price is on screen. A move-out can
  // be saved only when it is the lookup the pop-up needs now.
  const [quotedKey, setQuotedKey] = useState(null);
  // True when the price for the selected date could not be loaded.
  const [quoteFailed, setQuoteFailed] = useState(false);
  // Raised by Retry, and after a save, to ask for the same date's price again.
  const [quoteAttempt, setQuoteAttempt] = useState(0);
  // The request the latest price fetch was for. A reply for any other
  // (an earlier date, or before the order's return date changed) is stale
  // and ignored.
  const quoteFor = useRef(null);
  // Set synchronously while a save is in flight: the confirm dialog keeps its
  // own Yes button enabled, so state alone cannot stop a second submit.
  const saving = useRef(false);
  const [dropDown, setDropDown] = useState({ address: [] });
  const [dialogSave, setDialogSave] = useState({ type: false, discard: false });
  const [returnData, setReturnData] = useState(null);
  const [franchiseContainer, setFranchiseContainer] = useState(null);

  const dispatch = useDispatch();
  /** Close the pop-up. @returns {void} */
  const handleClose = () => setShow(false);
  /** Open the pop-up. @returns {void} */
  const handleShow = () => setShow(true);
  /**
   * Load the site's unit classes into the form's state.
   *
   * @param {number|string} id The selected site.
   * @returns {Promise<void>}
   */
  const handleClassList = async (id) => {
    await getClassSiteList(id).then((res) => {
      dispatchReducer({ type: "classSiteList", value: res.data.data });
    });
  };
  useEffect(() => {
    if (state?.siteSelect?.id) {
      handleClassList(state?.siteSelect?.id);
    }
  }, [state?.siteSelect?.id]);

  /**
   * Save the step. On the move-out tab nothing is sent until the price for
   * the selected date has loaded, so a ticked Storage Cost is never left out
   * or sent at an amount for another date. The ticked charges are added to a
   * copy of the form's values, so only this request carries them.
   *
   * @param {Object} values The form's values.
   * @returns {void}
   */
  const handleSubmit = (values) => {
    if (saving.current) {
      return;
    }
    saving.current = true;
    setIsLoading(true);
    if (keyC === "moveOut" && formik.values?.return_date === "") {
      setSnack({
        call: true,
        type: "error",
        message: "Select Date",
      });
      setIsLoading(false);
      saving.current = false;
      return;
    }
    if (quoteLoading) {
      setSnack({
        call: true,
        type: "error",
        message: "Wait for the price for this date",
      });
      setIsLoading(false);
      saving.current = false;
      return;
    }
    if (!moveOutPriceReady) {
      setSnack({
        call: true,
        type: "error",
        message: "The price for this date has not loaded. Retry it before saving.",
      });
      setIsLoading(false);
      saving.current = false;
      return;
    }

    // console.log("check-82", keyC);
    // if (keyC === "moveIn" && franchiseContainer.length) {
    //   const filteredAvailData = franchiseContainer.slice(0, +orderDetail?.pod);
    //   values.franchise_container_id = filteredAvailData.map((e) => e.id);
    // }

    // The charges go on a copy, never on the form's own values: those outlive
    // this request, so a charge set here would be sent again by the next Save
    // even after its box is unticked or the date changes.
    const payload = { ...values };
    if (keyC === "moveOut" && isSelected("pod_price")) {
      payload.is_return_cost = 1;
      payload.pod_price = value.pod_price;
    } else if (keyC === "return" && selectedItems.extra_return_fee_price) {
      payload.is_return_cost = 1;
    }
    if (keyC === "return" && selectedItems?.is_extra_miles) {
      payload.is_extra_miles = 1;
      payload.extra_miles_id = returnData?.extraMiles?.id;
      payload.extra_miles_quantity = returnData?.extraMiles?.qty;
      payload.extra_miles_charge = returnData?.extraMiles?.totalPrice;
    }

    containerDateUpdate(payload)
      .then((res) => {
        dispatch(fetchMyOrderDetailCard(values?.order_id));
        // What is left to charge has changed now the date is saved: ask
        // again, so a second Save cannot send the price just charged.
        setQuotedKey(null);
        setQuoteAttempt((n) => n + 1);
        setTimeout(() => {
          setShow(false);
        }, 2000);
        setSnack({
          call: true,
          type: "success",
          message: res?.data?.message || "",
        });
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setSnack({
          call: true,
          type: "error",
          message: error?.response?.data?.message || "",
        });
      })
      .finally(() => {
        saving.current = false;
      });
    // if (collectionData?.collection_date === "") {
    //   setSnack({
    //     call: true,
    //     type: "error",
    //     message: "Please Select Move In Date",
    //   });
    //   return;
    // }
    // dispatchReducer({
    //   type: "collectionRetrun",
    //   value: collectionData,
    // });
  };
  useEffect(() => {
    if (snack.call) {
      setTimeout(() => {
        setSnack({ call: false, type: "", message: "" });
      }, 4000);
    }
  }, [snack.call]);
  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });
  // Each time the pop-up is opened the Storage Cost box starts from its
  // default again; an untick is not carried over from an earlier opening.
  useEffect(() => {
    if (show) {
      setStorageCostChoice(null);
    }
  }, [show]);
  // The price lookup the pop-up needs now, or null when no date is picked:
  // the order, the tab, the picked date and the order's saved return date.
  // The price runs from the saved return date to the picked one, so it
  // changes once a move-out is saved even when the picked date does not.
  const quoteDate =
    keyC === "moveOut"
      ? formik?.values?.return_date
      : keyC === "return"
      ? formik?.values?.container_return_date
      : "";
  const quoteKey = quoteDate
    ? `${orderDetail?.id || ""}|${
        keyC === "moveOut" ? "move_out" : "return"
      }|${quoteDate}|${orderDetail?.return_date || ""}`
    : null;
  // A move-out with a date can be saved only once that date's price is in.
  const moveOutPriceReady =
    keyC !== "moveOut" || !quoteKey || quotedKey === quoteKey;
  /**
   * Mark the date as entered by hand, so it is saved as a manual choice.
   *
   * @returns {void}
   */
  const handleManualUpdate = () => {
    formik.setFieldValue("is_manual", 1);
  };
  useEffect(() => {
    if (quoteKey) {
      const data = {
        id: orderDetail?.id || "",
        type: keyC === "moveOut" ? "move_out" : "return",
        is_student_return: 0,
        return_date: quoteDate,
        container_size: orderDetail?.container_size,
      };
      // A new date, or a new saved return date, makes the price on screen
      // stale: clear it, so it can be neither shown nor charged, until the
      // price for this lookup arrives.
      const request = `${quoteKey}#${quoteAttempt}`;
      quoteFor.current = request;
      setValue({});
      setQuotedKey(null);
      setQuoteFailed(false);
      setQuoteLoading(true);
      containerExtraChage(data)
        .then((res) => {
          if (quoteFor.current !== request) {
            return; // for a lookup that is no longer the one needed
          }
          const prices = res?.data?.data;
          // A move-out price always carries pod_price; without it there is
          // nothing to charge from, so it counts as a failed lookup.
          if (
            !prices ||
            typeof prices !== "object" ||
            (data.type === "move_out" &&
              (prices.pod_price === undefined || prices.pod_price === null))
          ) {
            throw new Error("No price in the reply");
          }
          setValue(prices);
          setQuotedKey(quoteKey);
          setQuoteLoading(false);
        })
        .catch(() => {
          if (quoteFor.current !== request) {
            return;
          }
          setQuoteLoading(false);
          setQuoteFailed(true);
          setSnack({
            call: true,
            type: "error",
            message: "Could not get the price for this date",
          });
        });
    } else {
      // No date: drop any price still on screen or on its way.
      quoteFor.current = null;
      setQuoteLoading(false);
      setQuoteFailed(false);
      setQuotedKey(null);
      if (keyC === "return" || keyC === "moveOut") {
        setValue({});
      }
    }
  }, [
    keyC,
    formik?.values?.return_date,
    formik?.values?.container_return_date,
    orderDetail?.return_date,
    orderDetail?.id,
    orderDetail?.container_size,
    quoteDate,
    quoteKey,
    quoteAttempt,
  ]);

  /** Whether a booked move-out's Storage Cost is one this box decides. */
  const isMoveOutStorageCost = (itemName) =>
    keyC === "moveOut" && itemName === "pod_price";

  /**
   * Whether a charge's box is ticked.
   *
   * On the move-out tab, Storage Cost is ticked whenever there is a cost to
   * charge, unless staff have unticked it themselves since the pop-up opened.
   * It used to start unticked, so a move-out booked without touching the box
   * raised no end-of-term charge. Every other box starts unticked as before.
   *
   * @param {string} itemName The charge's key in the price response.
   * @returns {boolean}
   */
  const isSelected = (itemName) =>
    isMoveOutStorageCost(itemName)
      ? Number(value?.pod_price) > 0 && storageCostChoice !== false
      : !!selectedItems[itemName];

  /**
   * Tick or untick a charge. For the move-out Storage Cost the choice is
   * remembered while the pop-up is open, so changing the date (which fetches
   * the price again) does not tick it back.
   *
   * @param {string} itemName The charge's key in the price response.
   * @returns {void}
   */
  const handleCheckboxChange = (itemName) => {
    if (isMoveOutStorageCost(itemName)) {
      setStorageCostChoice(!isSelected(itemName));
      return;
    }
    setSelectedItems({
      ...selectedItems,
      [itemName]: !selectedItems[itemName],
    });
  };

  /**
   * The total of the ticked charges, rounded to the penny.
   *
   * @returns {number}
   */
  const getTotalPrice = () => {
    let total = 0;
    for (const itemName of new Set([
      ...Object.keys(selectedItems),
      "pod_price",
    ])) {
      if (isSelected(itemName)) {
        // As numbers: a price sent as text would otherwise be joined on.
        total += Number(value[itemName]) || 0;
      }
    }
    console.log("total", +total);

    // Round to 2 decimal places: decimal prices added as numbers can come
    // out as, say, 17.299999999999997.
    return Math.round(total * 100) / 100;
  };

  const handleGetAddress = async (return_postcode, check) => {
    if (!return_postcode) return;
    formik.setFieldValue("is_address_manual", "0");
    getAddress(return_postcode)
      .then((res) => {
        setDropDown({ address: res.data.addresses });
        formik.setFieldValue("city", res.data.addresses[0].town_or_city);
        if (check !== "onMount") {
          setSnack({
            call: true,
            type: "success",
            message: "Postcode found successfully",
          });
        }
      })
      .catch((error) => {
        formik.setFieldValue("street1", "");
        formik.setFieldValue("city", "");
        setSnack({
          call: true,
          type: "error",
          message: "Cannot find Post Code",
        });
      });
  };
  useEffect(() => {
    if (
      formik?.values?.return_postcode &&
      formik.values?.is_address_manual !== 1
    ) {
      handleGetAddress(formik?.values?.return_postcode, "onMount");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik?.values?.return_postcode]);
  /**
   * Calculates extra-miles charges for container collection by fetching directions between
   * the original collection address and the return address, then updates returnData and form state.
   * @returns {Promise<void>}
   */
  const handleResponse = async () => {
    setIsLoading(true);
    if (
      orderDetail?.is_return === 1 ||
      formik?.values?.is_student_return === 1
    ) {
      setIsLoading(false);
      return;
    }

    const origin =
      orderDetail?.collection_address_line +
      "," +
      orderDetail?.collection_address_city +
      "," +
      orderDetail?.collection_postcode;
    const destination =
      formik?.values?.return_address_line +
      "," +
      formik?.values?.return_address_city +
      "," +
      formik?.values?.return_postcode;

    try {
      const dirResponse = await axios.get(
        `${import.meta.env.REACT_APP_SITE_URL}directions`,
        {
          params: { origin, destination },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (dirResponse.data?.success && dirResponse.data?.data) {
        const dirData = dirResponse.data.data;
        const res = await extraMiles(orderDetail?.franchise_id);
        const response = res.data.data;

        const price = divideByHundred(
          response?.product_prices[0]?.unit_amount
        );
        let miles = (dirData.distance_miles - 10) || "-";
        let actualMiles = +miles > 0 ? +miles : 0;
        let Totalprice = calculateExtraPrice(
          Math.round(actualMiles),
          price
        );
        setReturnData((prevReturnData) => ({
          ...prevReturnData,
          extraMiles: {
            id: response.id,
            totalPrice:
              orderDetail?.booking_reference === "254-060223-47721"
                ? "60"
                : Totalprice,
            qty: Math.round(miles),
          },
        }));
        // From the latest price, not the one this lookup started with,
        // which may be for a date no longer selected.
        setValue((prev) => ({ ...prev, is_extra_miles: Totalprice }));
        setIsLoading(false);
      } else {
        console.error("Error fetching directions from API");
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching directions:", error);
      setIsLoading(false);
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => handleClose()}
        aria-labelledby="example-modal-sizes-title-lg"
        size="lg"
        contentClassName="modal-height"
      >
        <Modal.Header closeButton>
          <Modal.Title>Calendar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formik.handleSubmit}>
            <Paper square>
              <div className="row" style={{ padding: "12px" }}>
                <div className="col-12">
                  <ContainerModalCompoent
                    formik={formik}
                    keyC={keyC}
                    check={check}
                    orderDetail={orderDetail}
                    setFranchiseContainer={setFranchiseContainer}
                  />
                </div>

                {keyC === "return" && (
                  <div
                    key={`custom`}
                    className=" col-12 checkbox mb-3"
                    style={{ padding: "2%" }}
                  >
                    <Form.Check
                      className="mb-2"
                      custom
                      name="Checkboxes4"
                      checked={
                        keyC === "return" &&
                        formik?.values?.is_return_address == "0"
                          ? true
                          : false
                      }
                      type="checkbox"
                      id={`custom`}
                      label={`${capitalizeFirstLetter(
                        keyC
                      )} address same as ${"Collection"} address`}
                      onClick={() => {
                        if (formik.values.is_return_address !== 1) {
                          formik.setValues({
                            ...formik?.values,
                            is_return_address: 1,
                            return_postcode:
                              orderDetail?.collection_postcode || "",
                            return_address_line:
                              orderDetail?.collection_address_line || "",
                            return_address_city:
                              orderDetail?.collection_address_city,
                          });
                        } else {
                          formik.setValues({
                            ...formik?.values,
                            is_return_address: "0",
                          });
                        }
                      }}
                    />
                  </div>
                )}
                {formik.values.is_return_address == 1 && keyC === "return" && (
                  <div className="row col-12" style={{ padding: "2%" }}>
                    <div className="col-md-12 mb-5">
                      <label>{intl.formatMessage({ id: "Post.Code" })}</label>
                      <div className="row align-items-center">
                        <div className="col-6 d-flex justify-content-between align-items-center ">
                          <div className="form-groupB w-100">
                            <input
                              type="text"
                              className={`form-control  ${getInputClasses(
                                formik,
                                "return_postcode"
                              )}`}
                              placeholder={intl.formatMessage({
                                id: "Post.Code",
                              })}
                              name="return_postcode"
                              value={formik.values?.return_postcode}
                              onChange={(e) => {
                                const inputValue = e.target.value;

                                // Remove any non-alphanumeric characters from the input value
                                const alphanumericValue = inputValue.replace(
                                  /\W/g,
                                  ""
                                );

                                // Use regex to format the input value as a UK return_postcode
                                const formattedValue = alphanumericValue.replace(
                                  /^([A-Z]{1,2}\d{1,2}[A-Z]?)\s?(\d[A-Z]{2})$/i,
                                  "$1 $2"
                                );
                                formik.setFieldValue(
                                  "return_postcode",
                                  formattedValue
                                );
                              }}
                              // {...formik.getFieldProps("return_postcode")}
                            />
                          </div>
                          <div className="mb-2">
                            <span className="symbol-label ml-2">
                              <span
                                className="svg-icon svg-icon-lg svg-icon-primary"
                                onClick={() =>
                                  handleGetAddress(
                                    formik.values.return_postcode
                                  )
                                }
                              >
                                <SVG
                                  className="h-25 align-self-end"
                                  style={{ cursor: "pointer" }}
                                  title=" "
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Search.svg"
                                  )}
                                ></SVG>
                              </span>
                            </span>
                          </div>
                        </div>
                        <div className="col-md-6 mb-2 123">
                          <span
                            style={{
                              color: "#ff9f60",
                              cursor: "pointer",
                            }}
                            onClick={handleManualUpdate}
                          >
                            {intl.formatMessage({ id: "Enter.Manually" })}
                          </span>
                        </div>
                        {formik.touched.return_postcode &&
                        formik.errors.return_postcode ? (
                          <div className=" ml-4 mb-4 fv-plugins-message-container">
                            <div className="fv-help-block">
                              {formik?.errors?.return_postcode}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-12">
                      <label>Address</label>
                      <div className="form-groupB">
                        {formik.values.is_manual === 1 ? (
                          <input
                            type="text"
                            className={`form-control  ${getInputClasses(
                              formik,
                              "return_address_line"
                            )}`}
                            placeholder="address"
                            name="return_address_line"
                            {...formik.getFieldProps("return_address_line")}
                          />
                        ) : (
                          <FormControl fullWidth>
                            <Select
                              name="return_address_line"
                              MenuProps={{
                                anchorOrigin: {
                                  vertical: "bottom",
                                  horizontal: "left",
                                },
                                transformOrigin: {
                                  vertical: "top",
                                  horizontal: "left",
                                },
                                getContentAnchorEl: null,
                              }}
                              className={`form-control  ${getInputClasses(
                                formik,
                                "return_address_line"
                              )}`}
                              IconComponent={(props) => (
                                <i {...props}>
                                  <KeyboardArrowDownIcon />
                                </i>
                              )}
                              inputProps={{
                                "aria-label": "Without label",
                              }}
                              placeholder="Address"
                              displayEmpty
                              {...formik.getFieldProps("return_address_line")}
                            >
                              <MenuItem value="">
                                {intl.formatMessage({
                                  id: "return_address_line",
                                })}
                              </MenuItem>
                              {dropDown?.address && dropDown?.address.length > 0
                                ? dropDown?.address.map((data, index) => {
                                    let addressData = data?.formatted_address.toString();
                                    addressData = addressData?.replaceAll(
                                      ", ",
                                      ","
                                    );
                                    addressData = addressData?.replaceAll(
                                      ",, ",
                                      ","
                                    );
                                    addressData = addressData?.replaceAll(
                                      ",,,",
                                      ","
                                    );

                                    return (
                                      <MenuItem value={addressData} key={index}>
                                        {addressData}
                                      </MenuItem>
                                    );
                                  })
                                : null}
                            </Select>
                          </FormControl>
                        )}

                        {formik.touched.return_address_line &&
                        formik.errors.return_address_line ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {formik.errors.return_address_line}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-12">
                      <label>{intl.formatMessage({ id: "CITY" })}</label>
                      <div className="form-groupB">
                        <input
                          type="text"
                          className={`form-control  ${getInputClasses(
                            formik,
                            "return_address_city"
                          )}`}
                          placeholder={intl.formatMessage({ id: "CITY" })}
                          name="return_address_city"
                          {...formik.getFieldProps("return_address_city")}
                        />
                        {formik.touched.return_address_city &&
                        formik.errors.return_address_city ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {formik.errors.return_address_city}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {orderDetail?.is_return != 1 && (
                      <div className="col-12">
                        <Button
                          variant="primary"
                          type="button"
                          onClick={handleResponse}
                        >
                          Get Extra Miles
                          {isLoading && (
                            <span className="ml-2 mr-2 spinner spinner-white"></span>
                          )}
                        </Button>
                      </div>
                    )}
                  </div>
                )}

                <br />

                {keyC === "moveOut" &&
                orderDetail?.return_date &&
                formik.values.return_date &&
                new Date(orderDetail?.return_date).getTime() <
                  new Date(formik.values.return_date).getTime() ? (
                  <>
                    <div className="d-flex col-12">
                      <div>
                        <label class="checkbox">
                          <input
                            type="checkbox"
                            checked={
                              formik.values.is_penalty_charge == 1
                                ? true
                                : false
                            }
                            onChange={() =>
                              formik.setFieldValue(
                                "is_penalty_charge",
                                formik.values.is_penalty_charge == 1 ? 0 : 1
                              )
                            }
                          />
                          <span class="mr-2"></span>
                        </label>
                      </div>
                      <label>Apply Penalty Charge</label>
                    </div>
                    {formik.values.is_penalty_charge == 1 && (
                      <div className="col-12">
                        <label>Penalty(&pound;)</label>
                        <div className="form-groupB">
                          <input
                            type="text"
                            className={`form-control  ${getInputClasses(
                              formik,
                              "penalty_charge"
                            )}`}
                            placeholder={intl.formatMessage({
                              id: "penalty_charge",
                            })}
                            name="penalty_charge"
                            {...formik.getFieldProps("penalty_charge")}
                          />
                          {formik.touched.penalty_charge &&
                          formik.errors.penalty_charge ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {formik.errors.penalty_charge}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  ""
                )}
                {(keyC === "return" || keyC === "moveOut") && quoteFailed && (
                  <div
                    className="d-flex align-items-center"
                    style={{ padding: "2% 2% 0" }}
                  >
                    <span className="text-danger mr-3">
                      The price for this date could not be loaded.
                    </span>
                    <Button
                      variant="secondary"
                      size="sm"
                      onClick={() => setQuoteAttempt((n) => n + 1)}
                    >
                      Retry
                    </Button>
                  </div>
                )}
                {(keyC === "return" || keyC === "moveOut") && (
                  <div style={{ padding: "2%" }}>
                    {Object.keys(value).map((itemName, index) => {
                      if (itemName === "invoice_duration_line_items") {
                        return;
                      }

                      return (
                        <div key={index} className="d-flex">
                          <div>
                            <label class="checkbox">
                              <input
                                type="checkbox"
                                checked={isSelected(itemName)}
                                onChange={() => handleCheckboxChange(itemName)}
                              />
                              <span class="mr-2"></span>
                            </label>
                          </div>
                          <label>
                            {itemName === "pod_price"
                              ? "Storage Cost"
                              : itemName === "extra_return_fee_price"
                              ? "Return Fee"
                              : itemName === "is_extra_miles"
                              ? "Extra miles"
                              : itemName}
                            : &pound; {Number(value[itemName]).toFixed(2)}
                          </label>
                        </div>
                      );
                    })}
                    <div>Total: &pound;{getTotalPrice().toFixed(2)}</div>
                  </div>
                )}
              </div>
            </Paper>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            disabled={isLoading || quoteLoading || !moveOutPriceReady}
            onClick={() => setDialogSave({ type: true })}
          >
            Save Changes{" "}
            {(isLoading || quoteLoading) && (
              <span className="ml-2 mr-2 spinner spinner-white"></span>
            )}
          </Button>
        </Modal.Footer>
        {snack.call ? <SnackBarTool {...snack} /> : ""}
        <CustomeOrderSaveDialog
          header={intl.formatMessage({ id: "Save.Changes" })}
          mainText={intl.formatMessage({ id: "Do.you.changes.booking" })}
          dialog={dialogSave}
          setDialog={setDialogSave}
          type={"order"}
          formik={formik}
          check={keyC === "return" || keyC === "moveOut" ? "order" : ""}
          showCheck={"order"}
          dis={"no"}
          dialogConditionCheck={true}
        />
      </Modal>
    </>
  );
}
